import { useQuery } from '@apollo/client'
import { teacherRegistrationQuery } from '../../../appsync/graphql/teacher'
import { formatAppsyncErrors } from '../../../appsync/utils'

const useTeacherRegistrationQuery = ({ otherSkipConditions = false }) => {
  const {
    loading,
    error: rawError = null,
    data: rawData = {},
  } = useQuery(teacherRegistrationQuery, {
    variables: { isProfessional: true },
    skip: otherSkipConditions,
  })
  const data = rawData?.getTeacherRegistration ?? {}
  const error = rawError ? formatAppsyncErrors(rawError) : null

  return { data, loading, error }
}

export default useTeacherRegistrationQuery
